/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S11_Li1_EmInputs */

const tr_iade_iptal_s11_li1_em = /** @type {(inputs: Iade_Iptal_S11_Li1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/kvkk-haklar`)
};

const en_iade_iptal_s11_li1_em = /** @type {(inputs: Iade_Iptal_S11_Li1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/kvkk-haklar`)
};

const de_iade_iptal_s11_li1_em = /** @type {(inputs: Iade_Iptal_S11_Li1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/kvkk-haklar`)
};

const ru_iade_iptal_s11_li1_em = /** @type {(inputs: Iade_Iptal_S11_Li1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/kvkk-haklar`)
};

/**
* | output |
* | --- |
* | "/kvkk-haklar" |
*
* @param {Iade_Iptal_S11_Li1_EmInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s11_li1_em = /** @type {((inputs?: Iade_Iptal_S11_Li1_EmInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S11_Li1_EmInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s11_li1_em(inputs)
	if (locale === "de") return de_iade_iptal_s11_li1_em(inputs)
	if (locale === "ru") return ru_iade_iptal_s11_li1_em(inputs)
	return tr_iade_iptal_s11_li1_em(inputs)
});